export interface IToken {
  accessToken: string | null;
  refreshToken: string | null;
  businessportalAccessToken: string | null;
  businessportalRefreshToken: string | null;
}
export interface TokenUser {
  _id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  logo?: string;
  profileImage?: string;
  adminTypeId?: string;
}

export interface AdminType {
  _id?: string;
  adminTypeName?: string;
  defaultType: boolean;
  status: string;
  permissions: Module[];
}
export interface Module {
  moduleid: string;
  moduleName: string;
  read: boolean;
  write: boolean;
}

export interface BusinessUser {
  _id: string;
  email: string;
  status: string;
  businessSfId: string;
  name: string;
  ownerName: string;
  phoneNumber: string;
  workArea: string;
  city: string;
  street: string;
  houseNumber: string;
}
